import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
interface AngelFeedFiltersProps {
  activeFilter: string;
  setActiveFilter: (filter: string) => void;
}
export const AngelFeedFilters: React.FC<AngelFeedFiltersProps> = ({
  activeFilter,
  setActiveFilter
}) => {
  const filtersRef = useRef<HTMLDivElement>(null);
  const scrollFilters = (direction: 'left' | 'right') => {
    if (filtersRef.current) {
      const scrollAmount = direction === 'left' ? -200 : 200;
      filtersRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  const filters = [{
    id: 'all',
    label: 'All',
    icon: '🔥'
  }, {
    id: 'star',
    label: 'Star',
    icon: '⭐'
  }, {
    id: 'media',
    label: 'Media',
    icon: '📸'
  }, {
    id: 'voice',
    label: 'Voice',
    icon: '🎤'
  }, {
    id: 'missions',
    label: 'Missions',
    icon: '🎯'
  }, {
    id: 'moans',
    label: 'Moans',
    icon: '💋'
  }, {
    id: 'polls',
    label: 'Polls',
    icon: '📊'
  }, {
    id: 'upsells',
    label: 'Premium',
    icon: '💎'
  }, {
    id: 'rewards',
    label: 'Rewards',
    icon: '🏆'
  }, {
    id: 'shop',
    label: 'Shop',
    icon: '🛍️'
  }];
  return <div className="relative" data-id="element-1359">
      <button onClick={() => scrollFilters('left')} className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white/90 rounded-full text-of-text-secondary hover:text-of-text-primary shadow-sm" data-id="element-1360">
        <ChevronLeft size={18} data-id="element-1361" />
      </button>
      <div ref={filtersRef} className="flex overflow-x-auto py-2 px-8 scrollbar-hide" data-id="element-1362">
        {filters.map(filter => <button key={filter.id} onClick={() => setActiveFilter(filter.id)} className={`flex items-center gap-1.5 px-4 py-2 mx-1 rounded-full whitespace-nowrap transition-all ${activeFilter === filter.id ? 'bg-of-blue text-white' : 'bg-of-gray text-of-text-secondary hover:bg-of-gray-dark'}`} data-id="element-1363">
            <span data-id="element-1364">{filter.icon}</span>
            <span data-id="element-1365">{filter.label}</span>
          </button>)}
      </div>
      <button onClick={() => scrollFilters('right')} className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white/90 rounded-full text-of-text-secondary hover:text-of-text-primary shadow-sm" data-id="element-1366">
        <ChevronRight size={18} data-id="element-1367" />
      </button>
      <style jsx data-id="element-1368">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};